module.exports = __webpack_public_path__ + "static/media/eliminar.9714113a.svg";